<template>
    <div class="ms-4 mt-1 mb-4">

        <view-header v-if="showHeader" :table="table" :view="view" :parent-table="parentTable"
                     :parent-document="parentDocument"></view-header>

        <table class="table table-sm">
            <thead>
            <tr>
                <th v-for="field in listFields">{{field.name}}</th>
                <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="document in documents">
                <td v-for="(field, index) in listFields">
                    <router-link v-if="index === 0" :to="detailsRoute(document['id'])">
                        {{fieldValue(document, field)}}
                    </router-link>

                    <select-view v-else-if="field.field_type === 'Single Select'" :document="document"
                                 :field="field"></select-view>

                    <date-renderer v-else-if="field.field_type === 'Date' && fieldValue(document, field)"
                                   :document="document" :field="field"></date-renderer>

                    <checkbox-view v-else-if="field.field_type === 'Boolean'" :document="document"
                                   :field-name="field.index" :editable="false" :key="field.id + 'view'"
                                   :table="table"></checkbox-view>

                    <number-renderer v-else-if="isNumeric(field)" :document="document" :field="field"></number-renderer>

                    <attachment-viewer v-else-if="field.field_type === 'Attachment'" :attachments="attachments(field, document)"
                                       :document="document" :field="field" :table="table"></attachment-viewer>

                    <span v-else>
                        {{fieldValue(document, field)}}
                    </span>
                </td>

                <td>
                    <a href="javascript:void(0)" @click="onDeleteClick(document)"><i class="fad fa-times-circle text-secondary"></i></a>
                </td>
            </tr>
            </tbody>
        </table>

        <confirm-modal
                v-if="showConfirmModal"
                @noEvent="showConfirmModal = false"
                :yesEvent="deleteDocument"
                text="Are you sure you want to delete this data?">
        </confirm-modal>

    </div>
</template>

<script>
    import ViewService from "../../services/ViewService";
    import TableUtil from "../../utils/TableUtil";
    import SelectView from "../../components/SelectView.vue";
    import ViewHeader from "../ViewHeader.vue";
    import DateRenderer from "../../components/DateRenderer.vue";
    import CheckboxView from "../../components/CheckboxView.vue";
    import FieldUtil from "../../utils/FieldUtil";
    import NumberRenderer from "../renderers/NumberRenderer.vue";
    import DataService from "../../services/DataService";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import AttachmentViewer from "../controls/AttachmentViewer.vue";

    export default {
        name: 'TableView',
        components: {AttachmentViewer, ConfirmModal, NumberRenderer, CheckboxView, DateRenderer, ViewHeader, SelectView},
        props: {
            view: Object,
            table: Object,
            parentTable: Object,
            parentDocument: Object,
            showHeader: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                model: webase.model,
                tableUtil: new TableUtil(),
                dataService: new DataService(this.table.id),
                documents: [],
                showConfirmModal: false,
                deleteDocument: function () {
                }
            }
        },
        computed: {
            listFields() {
                return webase.utils.table.getListFields(this.table)
            },
            parentDocumentId() {
                return this.parentDocument ? this.parentDocument['id'] : null
            },
            isChildObject() {
                return this.table.parent ? true : false
            },
            findParentTable() {
                return webase.managers.app.getTable(this.table.parent)
            }
        },
        mounted() {
            this.loadData()
            webase.eventDispatcher.on('viewUpdated', this.loadData)
        },
        beforeUnmount() {
            webase.eventDispatcher.off('viewUpdated', this.loadData)
        },
        methods: {
            loadData() {
                let viewService = new ViewService()

                viewService.getData(this.view, this.table, this.parentDocumentId).then((response) => {
                    this.documents = response
                }).catch((message) => {
                    console.log('error loading data from table')
                    console.log(message)
                })
            },
            fieldValue(document, field) {
                if (field.field_type === 'Collaborator') {
                    return document[field.index].name
                }

                return document[field.index]
            },
            getFeaturedImage(record) {
                let attachmentData = record[this.attachment.index]

                if (attachmentData === undefined || attachmentData === null || attachmentData.length === 0) {
                    return null
                }

                let firstAttachment = attachmentData[0]

                if (!webase.utils.table.isImage(firstAttachment)) {
                    return null
                }

                let featureImageUrl = firstAttachment.url
                return featureImageUrl
            },
            detailsRoute(documentId) {
                if (this.parentTable && this.parentDocument) {

                    let routeParams = {
                        table_id: this.table.id,
                        record_id: documentId,
                        parentDocument: this.parentDocument,
                        parentTable: this.parentTable
                    }

                    return {name: 'static-details', params: routeParams}
                }

                return {name: 'static-details', params: {table_id: this.table.id, record_id: documentId}}
            },
            isNumeric(field) {
                return new FieldUtil(field).isNumeric()
            },
            onDeleteClick(document) {
                this.showConfirmModal = true
                this.deleteDocument = () => {
                    this.dataService.remove(document).then((response) => {
                        this.showConfirmModal = false
                        webase.utils.array.remove(this.documents, document['id'])
                    }).catch((message) => {
                        console.log('error deleting document')
                        console.log(message)
                        this.showConfirmModal = false
                    })
                }
            },
            attachments(field, document) {
                return document[field.index] ? document[field.index] : []
            }
        }
    }
</script>

<style>

</style>
